import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { DatePicker, Button } from "./index";
import DropDown from "./DropDown";
import styles from "./common.module.css";
import { CookieUtils } from "../axios.config";

const Filter = ({
  partner,
  setPartner,
  startDate, 
  setStartDate,
  endDate,
  setEndDate,
  status,
  setStatus,
  couponStatus,
  setCouponStatus,
  showCouponStatus = false,
  onSearch,
  loading = false,
  errorMessage,
  setErrorMessage = () => {},
  partnerList,
  showPartner = true,
  showStatus = false,
  nextStep,
  setNextStep,
  accountStatus,
  setAccountStatus,
  showNextStep = false,
  showAccountStatus = false,
  appName,
  setAppName,
  showAppName = false,
  fetchBy,
  setFetchBy,
  showFetchBy = false,
  mcbStatus,
  setMcbStatus,
  showMcbStatus = false,
  transactionStatus,
  setTransactionStatus,
  showTransactionStatus = false,
  transactionCurrency,
  setTransactionCurrency,
  showTransactionCurrency = false,
  fetchByOptions,
  buttonTitle = "Search",
  accountType,
  setAccountType,
  showAccountType = false,
  disableAccountType = false,
  disableFetchBy = false
  }) => {
   const [clientShowPartner, setClientShowPartner] = useState(false);
   const [isDateInvalid, setIsDateInvalid] = useState(false);
   useEffect(() => {
    const clientName = CookieUtils.get("clientName");
    setClientShowPartner(showPartner && clientName === "STOCKAL");
  }, [showPartner]);
  
  const activeFilters = [
    true,
    true,
    clientShowPartner,
    showStatus,
    showCouponStatus,
    showNextStep,
    showAccountStatus,
    showAppName,
    showFetchBy,
    showMcbStatus,
    showTransactionStatus,
    showTransactionCurrency,
    true,
  ].filter(Boolean).length;

  const colSize = activeFilters <= 4 ? 2 : 2;

  const statusOptions = [
    "PAYMENT_LINK_GEN",
    "HOLD",
    "DOC_RECEIVED",
    "transaction_verified",
    "EXPIRED",
    "COMPLETED",
    "PROCESSED",
    "LRS_PROCESS",
    "A2_E_SIGNED",
    "CANCELLED",
    "REJECTED",
    "FUND_RECEIVED",
    "Initiated",
    "Quote_Declined",
    "REFUNDED",
    "QUOTE_INITIATED",
    "WAITING_FOR_FUND",
  ];
const accountTypeOptions = [
  { label: "All",    value: "All" },
  { label: "Lien",   value: "GLOBAL_LIEN" },
  { label: "Unlien", value: "GLOBAL" },
];
  const onboardingStageOptions = [
    "ADDRESS",
    "DOCUMENTS",
    "FINANCIAL_DETAILS",
    "LEGAL_DETAILS",
    "PAN_DETAILS",
    "PERSONAL_DETAILS",
    "POLITICALLY_EXPOSED",
    "MANUAL_REVIEW",
    "COMPLETE",
  ];
  const appNameOptions = [
    "API",
    "API-V2",
    "DASHBOARD-INVESTING",
    "DASHBORD-EASY-REMIT",
    "DASHBORD-INVESTING",
    "EASY_REMIT",
    "Investing",
    "MCB",
    "easy-remit",
    "investing ",
  ];

  const accountStatusOptions = [
    "APPROVED",
    "REJECTED",
    "PENDING",
    "CLOSED",
    "KYC_MANUAL_REVIEW",
  ];
  const couponStatusoptions = [
    "ACTIVE",
    "INACTIVE"
  ];

  const displayFetchBy = {
    created: "Created Date",
    executedDate: "Executed Date",
  };

  const mcbStatusOptions = ["PENDING", "APPROVED", "REJECTED", "DISABLED"];

  const transactionStatusOptions = [
    "REJECTED",
    "SENT",
    "PAID",
    "FUNDED",
    "PROCESSING",
    "PENDING",
    "FAILED",
    "COMPLETED",
  ];
  const transactionCurrencyOptions = ["GBP", "CAD", "EUR", "SGD", "AUD", "USD"];

  const fetchByOptionsFormatted = fetchByOptions ? 
    Object.keys(fetchByOptions).map(key => ({
      label: displayFetchBy[fetchByOptions[key]] || fetchByOptions[key],
      value: fetchByOptions[key]
    })) : [];

  return (
    <Row className={styles.filterRow}>
      <Col md={colSize}>
        <label className={styles.label}>Start Date</label>
        <div className={styles.datestyle}>
          <DatePicker
            placeholderText="Select Start Date"
            dateFormat="yyyy-MM-dd"
            selected={startDate}
            onChange={(date) => {
              setStartDate(date);
              if (endDate && date && endDate < date) {
                setErrorMessage("End date cannot be before start date");
                setIsDateInvalid(true);
              } else {
                setErrorMessage("");
                setIsDateInvalid(false);
              }
            }}
            minDate={new Date("2016-01-01")}
            maxDate={new Date()}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
          />
        </div>
        {errorMessage && (
          <div className={styles.errorMessage}>{errorMessage}</div>
        )}
      </Col>
      <Col md={colSize}>
        <label className={styles.label}>End Date</label>
        <div className={styles.datestyle}>
          <DatePicker
            placeholderText="Select End Date"
            dateFormat="yyyy-MM-dd"
            selected={endDate}
            onChange={(date) => {
              setEndDate(date);
              setIsDateInvalid(false);
              if (errorMessage) setErrorMessage("");
            }}
            onChangeRaw={(e) => {
              const inputDate = new Date(e.target.value);
              if (startDate && inputDate < startDate) {
                setErrorMessage("End date cannot be before start date");
                setEndDate(inputDate);
                setIsDateInvalid(true);
              } else {
                setErrorMessage("");
                setIsDateInvalid(false);
              }
            }}
            minDate={startDate}
            maxDate={new Date()}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
          />
        </div>
      </Col>
      {clientShowPartner && (
        <Col md={colSize}>
          <DropDown
            label="Partner"
            value={partner}
            data={partnerList}
            onChange={(value) => {
              setPartner(value);
              if (errorMessage) setErrorMessage("");
            }}
            placeholder="Select Partner"
            height="40px"
            scrollbar={false}
          />
        </Col>
      )}
      {showStatus && (
        <Col md={colSize}>
          <DropDown
            label="Status"
            value={status}
            data={statusOptions}
            onChange={setStatus}
            placeholder="Select Status"
            height="40px"
            scrollbar={false}
          />
        </Col>
      )}
      {showCouponStatus && (
        <Col md={colSize}>
          <DropDown
            label="Status"
            value={couponStatus}
            data={couponStatusoptions}
            onChange={setCouponStatus}
            placeholder="Select Status"
            height="40px"
            scrollbar={false}
          />
        </Col>
      )}
      {showNextStep && (
        <Col md={colSize}>
          <DropDown
            label="Onboarding Stage"
            value={nextStep}
            data={onboardingStageOptions}
            onChange={setNextStep}
            placeholder="Select Stage"
            height="40px"
            scrollbar={false}
          />
        </Col>
      )}
      {showAccountStatus && (
        <Col md={colSize}>
          <DropDown
            label="Account Status"
            value={accountStatus}
            data={accountStatusOptions}
            onChange={setAccountStatus}
            placeholder="Select Status"
            height="40px"
            scrollbar={false}
          />
        </Col>
      )}

      {showAppName && (
        <Col md={colSize}>
          <DropDown
            label="App Name"
            value={appName}
            data={appNameOptions}
            onChange={setAppName}
            placeholder="Select App Name"
            height="40px"
            scrollbar={false}
          />
        </Col>
      )}
      {showFetchBy && (
        <Col md={colSize}>
          <DropDown
            label="Report Type"
            value={fetchBy}
            data={fetchByOptionsFormatted}
            onChange={(value) => {
              setFetchBy(value);
              if (errorMessage) setErrorMessage("");
            }}
            placeholder="Select Report Type"
            height="40px"
            scrollbar={false}
            labelKey="label"
            valueKey="value"
            disabled={disableFetchBy}
          />
        </Col>
      )}
       {showAccountType && (
        <Col md={colSize}>
          <DropDown
            label="Account Type"
            value={accountType}
            data={accountTypeOptions}
            onChange={disableAccountType ? () => {} : setAccountType}
            placeholder="Select Account Type"
            height="40px"
            scrollbar={false}
            labelKey="label"
            valueKey="value"
            disabled={disableAccountType}
          />
        </Col>
      )}
      {showMcbStatus && (
        <Col md={colSize}>
          <DropDown
            label="Status"
            value={mcbStatus}
            data={mcbStatusOptions}
            onChange={setMcbStatus}
            placeholder="Select MCB Status"
            height="40px"
            scrollbar={false}
          />
        </Col>
      )}

      {showTransactionStatus && (
        <Col md={colSize}>
          <DropDown
            label="Status"
            value={transactionStatus}
            data={transactionStatusOptions}
            onChange={setTransactionStatus}
            placeholder="Select Status"
            height="40px"
            scrollbar={false}
          />
        </Col>
      )}
      {showTransactionCurrency && (
        <Col md={colSize}>
          <DropDown
            label="Currency"
            value={transactionCurrency}
            data={transactionCurrencyOptions}
            onChange={setTransactionCurrency}
            placeholder="Select Currency"
            height="40px"
            scrollbar={false}
            formatValue={(val) => {
              if (!val) return "";
              return typeof val === "object" ? val.label ?? val.value : val;
            }}
          />
        </Col>
      )}
      <Col md={colSize} className={styles.searchButton}>
        <Button
          title={buttonTitle}
          loading={loading}
          onClick={onSearch}
          disabled={
            loading || isDateInvalid ||
            (partner === "" &&
              startDate === "" &&
              endDate === "" &&
              (!showStatus || status === "") &&
              (!showNextStep || nextStep === "") &&
              (!showAccountStatus || accountStatus === ""))
          }
        />
      </Col>
    </Row>
  );
};

export default Filter;
